import entitiesReducer from './reducer';

export default entitiesReducer;



// WEBPACK FOOTER //
// ./src/store/entities/index.js